<template>
  <div class="position_relative">
    <div class="padding_content" id="padding_wifi" style="padding-bottom: 80px;">
      <div id="wifi_container">
        <div class="wifi_selection">
          <img src="../../assets/img/search-wifi.png" alt="" />
          <h3>{{ $t('wifi.wifiService') }}</h3>
          <div class="color_gray">{{ $t('wifi.help') }}</div>
          <p>{{ $t('wifi.ARP') }}</p>
          <p>{{ $t('wifi.DNS') }}</p>
          <p>{{ $t('wifi.SSL') }}</p>
          <p>{{ $t('wifi.Weak') }}</p>
          <p>{{ $t('wifi.Device') }}</p>
        </div>
        <div class="better_suits">
          <h3 class="choose">{{ $t('service.screenshot') }}</h3>
          <div class="screenshot">
              <img class="img" src="../../assets/img/wifi-scan.png">
          </div>
        </div>
        <div class="wifi_api">
          <h3 class="choose">{{ $t('service.choose') }}</h3>
          <div class="better_suits">
            <p>{{ $t('service.apiLevel') }}</p>
            <div class="single_product">
              <div class="product_li">
                <h3 class="title">{{ $t('wifi.free') }}</h3>
                <p class="way">{{ $t('service.monthly') }}</p>
                <div class="description">
                  <p>{{ $t('wifi.desc1') }}</p>
                  <p>{{ $t('wifi.desc2') }}</p>
                  <p>{{ $t('wifi.desc3') }}</p>
                  <p>{{ $t('wifi.desc4') }}</p>
                  <p>{{ $t('wifi.desc5') }}</p>
                </div>
                <div class="select_btn" @click="jump('/support')">{{ $t('service.download') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <serviceFooter @scale="scale" :service="service"></serviceFooter>
    <loading :show="loading"></loading>
  </div>
</template>

<script>
import { downAPP } from '../public/validator'
import serviceFooter from './footer'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'WiFiSecurityDetection',
  components: { serviceFooter },
  data() {
    return {
      product: {},
      loading: true,
      service: 'wifi'
    }
  },
  methods: {
    jump(url) {
      this.$router.push(url).catch(err => {
        // to hide the below error message
        if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
          throw Error(err)
        }
      })
    }
  },
  mounted() {
    downAPP('padding_wifi', '180px')
  }
}
</script>

<style lang="scss" src="./service.scss" scoped></style>
<style lang="scss" scoped>
.wifi_selection {
  height: 293px;
  @include border-radius(6px);
  background: $white;
  position: relative;
  text-align: center;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
  & > h3 {
    width: 100%;
    height: 24px;
    font-size: 20px;
    font-family: NexaBold;
    color: rgba(31, 37, 62, 1);
    line-height: 24px;
    padding: 40px 0 17px;
  }
  & > img {
    width: 140px;
    height: 140px;
    @include absolute-left-top(0, 0);
  }
  .color_gray {
    height: 19px;
    font-size: 16px;
    font-family: NexaLight;
    font-weight: 400;
    color: rgba(31, 37, 62, 0.7);
    line-height: 19px;
    margin-bottom: 33px;
  }
  & > p {
    height: 30px;
    font-size: 14px;
    font-family: Lato-Regular;
    font-weight: 500;
    color: rgba(31, 37, 62, 0.9);
    line-height: 30px;
  }
}
.product_li .title {
  height: 48px;
  font-size: 40px;
  font-family: Lato-Bold;
  font-weight: bold;
  color: rgba(31, 37, 62, 1);
  line-height: 48px;
  padding: 36px 0 4px;
  text-align: center;
}

@media screen and (max-width: 450px) {
  .wifi_selection {
    & > img {
      width: 60px;
      height: 60px;
    }
    & > h3 {
      font-size: 14px;
      padding: 40px 0 4px;
    }

    .color_gray {
      font-size: 12px;
    }

    & > p {
      font-size: 12px;
    }
  }
  .product_li .title {
    font-size: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/service/wifi.vue